module.exports = "build/assets/graph3.2667a401.png";